import React, { Component } from 'react';
import { Route } from 'react-router';
import { BrowserRouter as Router } from 'react-router-dom';
import { MuiThemeProvider } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Navigator from './navigator';
import Login from './login';
import ForgotPassword from './forgot-password';
import Main from './main';
import Signage from './signage';
import Notification from './notification';
import { AlertDialog } from './components';
import Theme from './app.theme';

class App extends Component {
  render() {
    return (

      <Router basename={'/waiter'}>
        <MuiThemeProvider theme={Theme}>
          <Notification />
          <AlertDialog />
          <Navigator history={this.props.history} />
          <Route path="/login" component={Login} />
          <Route path="/forgotPassword" component={ForgotPassword} />
          <Route path="/" exact component={Main} />
          <Route path="/:locationId/signage" exact component={Signage} />
        </MuiThemeProvider>
      </Router>
    );
  }
}

App.propTypes = {
  history: PropTypes.any.isRequired,
};

export default App;
